import React from "react";
import { Link } from "react-router-dom";

import apps from '../assets/images/apps/2.png'

import { MdOutlineCheckCircle, FiArrowRight } from '../assets/icons/icons'

export default function Analytics(){
    return(
        <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
                <img src={apps} className="img-fluid" alt=""/>
            </div>

            <div className="col-lg-7 col-md-6 mt-4 mt-am-0 pt-2 pt-sm-0">
                <div className="ms-lg-5">
                    <div className="section-title">
                        <h6 className="text-primary">Analytics</h6>
                        <h4 className="title mb-4">Organize your work <br/> anywhere</h4>
                        <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                    
                        <ul className="list-unstyled text-muted mt-3">
                            <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                            <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                            <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                        </ul>

                        <div className="mt-4">
                            <Link to="#" className="btn btn-soft-primary">Try for free <FiArrowRight className="fea icon-sm"/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}